import { useEffect, useState, useRef } from 'react';

const useStickyHeader = (threshold = 50) => {
  const [isOverlay, setIsOverlay] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const shouldOverlay = scrollY > threshold;

      setIsOverlay((prevIsOverlay) => {
        if (shouldOverlay !== prevIsOverlay) {
          if (headerRef.current) {
            headerRef.current.classList.toggle('header--overlay', shouldOverlay);
          }

          // Add/remove top padding to body to prevent content jump
          if (shouldOverlay && headerRef.current) {
            const headerHeight = headerRef.current.offsetHeight;
            document.body.style.paddingTop = `${headerHeight}px`;
          } else {
            document.body.style.paddingTop = '0';
          }

          return shouldOverlay;
        }
        return prevIsOverlay;
      });
    };

    // Throttle scroll events for performance (~60fps)
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  }, [threshold]);

  return { headerRef, isOverlay };
};

export default useStickyHeader;

